import Position from "../types/PositionType";

export const calculateDistance = (
  position: Position,
  x: number,
  y: number
): number => {
  const xDifference = position.x - x;
  const yDifference = position.y - y;
  return Math.hypot(xDifference, yDifference);
};

const resolutions = [
  { width: 854, height: 480, scale: 0.445 }, // 480p
  { width: 1280, height: 720, scale: 0.667 }, // 720p
  { width: 1920, height: 1080, scale: 1 }, // 1080p
];
// Function to set the closest 16:9 resolution
export const setCanvasSize = () => {
  const { innerWidth, innerHeight } = window;

  // Find the highest available resolution that fits the screen
  let selectedResolution = resolutions[resolutions.length - 1]; // Default to the lowest (480p)

  for (const resolution of resolutions) {
    if (resolution.width <= innerWidth && resolution.height <= innerHeight) {
      selectedResolution = resolution; // Update to the highest resolution that fits
    } else {
      break; // No need to check further
    }
  }

  return selectedResolution;
};

export const scalePositionToResolution = (
  position: Position,
  width: number = 1920
): Position => {
  const { scale } = resolutions.filter(
    (resolution) => resolution.width === width
  )[0];
  const a = position.x * scale;
  const b = position.y * scale;
  return { x: a, y: b };
};

export const getScaleToResolution = (width: number = 1920): number => {
  return resolutions.filter((resolution) => resolution.width === width)[0]
    .scale;
};
